import ReactSelect, { GroupBase, Props as SelectProps } from 'react-select';

interface CustomSelectProps<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
> extends SelectProps<Option, IsMulti, Group> {
  isError?: boolean;
}

const customSelectStyles = {
  control: (provided: any, state: any) => ({
    ...provided,
    border: '1px solid #ffb868',
    borderRadius: '12px',
    boxShadow: state.isFocused
      ? '0 0 0 3px rgba(255, 159, 36, 0.15)'
      : 'inset 0 1px 2px rgba(0, 0, 0, 0.12)',
    fontSize: '14px',
    fontFamily: '"DM Sans", sans-serif',
    fontWeight: '400',
    lineHeight: '20px',
    letterSpacing: '0.01em',
    backgroundColor: '#fff',
    minHeight: '44px',
    height: state.selectProps.isMulti ? 'auto' : '44px',
    alignItems: state.selectProps.isMulti ? 'flex-start' : 'center',
    '&:hover': {
      border: '1px solid #ffb868',
    },
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: '#888',
    opacity: 1,
    fontSize: '14px',
    fontFamily: '"DM Sans", sans-serif',
    fontWeight: '400',
  }),
  singleValue: (provided: any) => ({
    ...provided,
    color: '#1a1a1a',
    fontSize: '14px',
    fontFamily: '"DM Sans", sans-serif',
    fontWeight: '400',
  }),
  dropdownIndicator: (provided: any) => ({
    ...provided,
    color: '#888',
    padding: '0 6px',
    '&:hover': {
      color: '#666',
    },
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    padding: '2px 8px',
    minHeight: '36px',
    height: 'auto',
    flexWrap: 'wrap',
    overflow: 'visible',
  }),
  multiValue: (provided: any) => ({
    ...provided,
    maxWidth: '100%',
  }),
  multiValueLabel: (provided: any) => ({
    ...provided,
    whiteSpace: 'normal',
  }),
  input: (provided: any) => ({
    ...provided,
    margin: '0',
    padding: '0',
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? '#ff9f24'
      : state.isFocused
        ? '#fff3e0'
        : '#fff',
    color: state.isSelected ? '#fff' : '#000',
    fontSize: '14px',
    fontFamily: '"DM Sans", sans-serif',
    fontWeight: '300',
    cursor: 'pointer',
  }),
  menu: (provided: any) => ({
    ...provided,
    borderRadius: '10px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    overflow: 'hidden',
  }),
};

function Select<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({ isError, ...props }: CustomSelectProps<Option, IsMulti, Group>) {
  const styles = isError
    ? {
        ...customSelectStyles,
        control: (provided: any, state: any) => ({
          ...customSelectStyles.control(provided, state),
          border: '2px solid #e53e3e',
          '&:hover': { border: '2px solid #e53e3e' },
        }),
      }
    : customSelectStyles;
  return <ReactSelect {...props} styles={styles as any} />;
}

export default Select;
